import Firebase from 'firebase'

const config = {
   apiKey: "AIzaSyCLE9AHpK5-OFDGfLZ8X0SxLh9XwR0nRxQ",
   authDomain: "namefinder-936ee.firebaseapp.com",
   databaseURL: "https://namefinder-936ee.firebaseio.com",
   storageBucket: "namefinder-936ee.appspot.com",
   messagingSenderId: "923738600597"
 };

let app = Firebase.initializeApp(config)
let fireDB;

export const db = () => {
  if (!fireDB) {
    fireDB = app.database()
  }
  return fireDB
}



// WEBPACK FOOTER //
// ./src/firebase.js